<template>
    <nav
        ref="menuRef"
        v-qa="'header-menu'"
        class="header-menu"
        data-allow-mismatch
    >
        <div
            class="header-menu-mobile-wrapper"
            :class="classHeaderMenuMobileWrapper"
        >
            <Transition
                :css="false"
                @before-enter="onBeforeEnter"
                @enter="onEnter"
                @after-enter="onAfterEnter"
                @leave="onLeave"
            >
                <HeaderMenuMobile
                    v-if="isMenuMobileOpen"
                    :main-menu="mainMenu"
                    @toggle-login-form="toggleLoginForm"
                    @close="closeMenuMobile"
                    @are-sub-menus-closed="areSubMenusClosed = $event"
                />
            </Transition>
        </div>

        <HeaderMenuDesktop
            v-if="!isMobile"
            :main-menu="mainMenu"
        />

        <HeaderMenuList
            v-if="isMobile"
            :main-menu="mainMenu"
        />
    </nav>
</template>

<script setup lang="ts">
import { type Ref, computed, ref, defineAsyncComponent } from 'vue'
import type { HeaderMenuFragment } from '@/graphql/api'
import { useHeaderMenuTransitionHooks } from './mobile/useHeaderMenuTransitionHooks'

// import HeaderMenuDesktop from './HeaderMenuDesktop.vue'
// import HeaderMenuMobile from './HeaderMenuMobile.vue'
// import HeaderMenuList from './HeaderMenuList.vue'

const HeaderMenuDesktop = defineAsyncComponent({
    loader: () => import('./HeaderMenuDesktop.vue'),
})
const HeaderMenuMobile = defineAsyncComponent({
    loader: () => import('./HeaderMenuMobile.vue'),
})
const HeaderMenuList = defineAsyncComponent({
    loader: () => import('./HeaderMenuList.vue'),
})

const props = defineProps<{
    mainMenu: HeaderMenuFragment[]
    isMenuMobileOpen: boolean
    isMobile: boolean
}>()

const emit = defineEmits<{
    'toggle-login-form': []
    'close-menu-mobile': []
    'open-menu-mobile': []
}>()

const toggleLoginForm = () => {
    emit('toggle-login-form')

    closeMenuMobile()
}
const closeMenuMobile = () => emit('close-menu-mobile')

const menuRef: Ref<HTMLElement | null> = ref(null)
const areSubMenusClosed = ref(true)

const { onBeforeEnter, onEnter, onAfterEnter, onLeave } =
    useHeaderMenuTransitionHooks(
        menuRef,
        closeMenuMobile,
        () => emit('open-menu-mobile'),
        areSubMenusClosed
    )

const classHeaderMenuMobileWrapper = computed(() => ({
    'is-mobile-menu-open': props.isMenuMobileOpen,
}))
</script>

<style lang="scss" scoped>
.header-menu {
    .header-menu-mobile-wrapper {
        position: fixed;
        width: 100%;
        bottom: 0;
        height: 100vh;
        left: 0;
        top: 0;
        pointer-events: none;

        @include min-width(1024) {
            display: none;
        }

        &.is-mobile-menu-open {
            pointer-events: auto;
        }
    }
}

.slide-enter-active,
.slide-leave-active,
.slide-reverse-enter-active,
.slide-reverse-leave-active {
    transition: transform 175ms var(--timing-function-easing-accelerate);
}

.slide-enter-from,
.slide-reverse-leave-to {
    transform: translate3d(100%, 0, 0);
}

.slide-leave-to,
.slide-reverse-enter-from {
    transform: translate3d(100%, 0, 0);
}
</style>
